import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import { toast } from "react-toastify";
import axios from "axios";
import Select from "react-select";
import DatePicker from "react-date-picker";
import moment from 'moment';

const AddCashSales = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const selectInputRef = useRef();
    const [invoiceDate, setInvoiceDate] = useState();
    const [lrDate, setLrDate] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [loading, setLoading] = useState(true);
    const [products, setProducts] = useState([]);
    const [items, setItems] = useState([]);
    const [productData, setProductData] = useState({
        name: "",
        product_id: null,
        sub_product_id: null,
        grade_name: "",
        grade_id: "",
        gst: "",
        qty: "",
        rate: "",
        amount: "",
    });

    const [formData, setFormData] = useState({
        "party_name": "",
        "party_address": "",
    });
    const styles = {
        menu: (baseStyles, state) => ({
            ...baseStyles,
            marginTop: 2,
            zIndex: 999,
        }),
    };

    const getEdit = () => {
        axios.post(API_URL.CASH_SALES_GET, { id: id }).then((res) => {
            if (res.data.status == 1) {
                setFormData({
                    "party_name": (res.data.data.party_name) ? res.data.data.party_name : "",
                    "party_address": (res.data.data.party_address) ? res.data.data.party_address : "",
                });
                if (res.data.data.date) {
                    setInvoiceDate(new Date(res.data.data.date));
                }
                if (res.data.data.lr_date) {
                    setLrDate(new Date(res.data.data.lr_date));
                }
                let rows = res.data.data.items.map((row) => {
                    return {
                        name: row.product.name,
                        gst: row.product.gst,
                        qty: row.qty,
                        rate: row.rate,
                        amount: row.amount,
                        product_id: row.product_id,
                        grade_id: row.grade_id,
                        grade_name: row.grade?.name,
                        sub_product_id: row.sub_product_id
                    }
                });
                setItems(rows);
            } else {
                toast.error(res.data.data, { autoClose: 3000 });
            }
        });
    }

    const getProducts = () => {
        axios.post(API_URL.PRODUCT_WITH_SUB_LIST, {}).then((res) => {
            if (res.data && res.data.data && res.data.data.length > 0) {
                res.data.data.map((raw) => {
                    raw.label = raw.name;
                    raw.value = raw.id;
                });
                setProducts(res.data.data);
            }
            if (!id) {
                setLoading(false);
            }
        });
    };


    const setProductValue = (e) => {
        if (e) {
            setProductData({
                ...productData,
                name: e ? e.label : "",
                product_id: e ? e.product_id : null,
                sub_product_id: e ? e.sub_product_id : 0,
                gst: e ? e.gst : 0,
                rate: e.price ? e.price: 0,
                amount: (productData.qty) ? (productData.qty * e.price) : 0,
            });
            console.log(e);
        }
    }

    const addRow = () => {
        if (productData.product_id && productData.qty && productData.rate && productData.amount) {
            let cloneItems = [...items];
            cloneItems.push(productData);
            setItems(cloneItems);
            setProductData({
                name: "",
                product_id: null,
                sub_product_id: null,
                grade_id: "",
                grade_name: "",
                gst: "",
                qty: "",
                rate: "",
                amount: "",
            });
            selectInputRef.current.clearValue();
        }
    }
    const updateValue = (name, amt, value, k) => {
        const copyData = [...items]
        if (copyData[k]) {
            copyData[k][name] = value;
            if (name === 'qty')
                copyData[k][amt] = value * copyData[k]['rate']
            if (name === 'rate')
                copyData[k][amt] = value * copyData[k]['qty']

        }
        setItems(copyData);
    }

    const deleteRow = (index) => {
        const copyData = [...items]
        let newData = copyData.filter((e, key) => {
            return key != index;
        });
        setItems(newData)
    }

    const calculations = () => {
        let sub_total = 0;
        let total_qty = 0;
        let tax_amount = 0;
        items.forEach((row) => {
            sub_total += parseFloat(row.amount);
            total_qty += parseFloat(row.qty);
            tax_amount += (parseFloat(row.amount) * parseFloat(row.gst)) / 100;
        });
        let insurance_amount = 0;
        if (formData.insurance) {
            insurance_amount = (sub_total * formData.insurance) / 100;
            insurance_amount = insurance_amount.toFixed(2);
        }
        sub_total = sub_total.toFixed(2);
        let total_amount = parseFloat(sub_total) + parseFloat(insurance_amount);
        if (formData.round_off) {
            total_amount = parseFloat(total_amount) + parseFloat(formData.round_off);
        }
        if (tax_amount) {
            tax_amount = tax_amount.toFixed(2);
            total_amount = parseFloat(total_amount) + parseFloat(tax_amount);
        }
        total_amount = total_amount.toFixed(2);
        setFormData({
            ...formData,
            sub_total: sub_total,
            insurance_amount: insurance_amount,
            total_qty: total_qty,
            tax_amount: tax_amount,
            total_amount: total_amount,
        });
    }

    const isValidForm = () => {
        return (
            formData.party_name &&
            formData.party_address &&
            formData.sub_total &&
            formData.total_amount &&
            invoiceDate &&
            items.length
        );
    };

    const onSave = () => {
        let payload = { ...formData };
        payload.items = [...items];
        payload.date = moment(invoiceDate).format('YYYY-MM-DD');
        if (lrDate) {
            payload.lr_date = moment(lrDate).format('YYYY-MM-DD');
        }
        const pUrl = id ? API_URL.CASH_SALES_UPDATE : API_URL.CASH_SALES_SAVE;
        if (id) {
            payload.id = id;
        }
        setIsLoading(true);
        axios.post(pUrl, payload).then((res) => {
            if (res.data.status === 1) {
                if (id) {
                    toast.success("Updated", {
                        autoClose: 3000,

                    });
                } else {
                    toast.success("Saved", { autoClose: 3000 });
                }
                setTimeout(() => {
                    navigate("/sales/cash-sales", { replace: true });
                }, 100);
            } else {
                toast.error(res.data.data, { autoClose: 3000 });
            }
            setIsLoading(false);
        }, (error) => {
            setIsLoading(false);
        });
    }

    useEffect(() => {
        calculations();
    }, [items, formData.insurance, formData.round_off])

     useEffect(() => {
           getProducts();
       }, [])


    useEffect(() => {
        if (id) {
            getEdit()
        }
    }, [id])
    return (
        <>
            <div className="row">
                <div className="col-6">
                    <h1>{id ? "Edit" : "Add"} Cash Sales</h1>
                </div>
                <div className="col-6">
                    <div className="d-flex align-items-center  justify-content-end">
                        <Link to={"/sales/cash-sales"} className="btn btn-secondary">
                            <i className="fa fa-backward me-2" aria-hidden="true"></i>Back
                        </Link>
                    </div>
                </div>
                <div className="col-12">
                    <form onSubmit={(event) => event.preventDefault()}>
                        <div className="row mb-3">
                            <div className="col-md-12">
                                <div className="card">
                                    <div className="card-header">Company Details</div>
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>Party<span className="required-star">*</span></label>
                                                    <input
                                                        type="text"
                                                        name="name"
                                                        maxLength={30}
                                                        value={formData.party_name}
                                                        className="form-control"
                                                        id="name"
                                                        onChange={(event) => {
                                                            setFormData({ ...formData, party_name: event.target.value });
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>Address<span className="required-star">*</span></label>
                                                    <input
                                                        type="text"
                                                        name="name"
                                                        maxLength={30}
                                                        value={formData.party_address}
                                                        className="form-control"
                                                        id="name"
                                                        onChange={(event) => {
                                                            setFormData({ ...formData, party_address: event.target.value });
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label htmlFor="">Date<span className="required-star">*</span></label>
                                                    <DatePicker
                                                        className="form-control"
                                                        onChange={setInvoiceDate}
                                                        value={invoiceDate}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="col-md-12">
                                <div className="card">
                                    <div className="card-header">Product Details</div>
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-md-5">
                                                <div className="form-group">
                                                    <label htmlFor="exampleInputEmail1">Product</label>
                                                    <Select
                                                        ref={selectInputRef}
                                                        options={products}
                                                        styles={styles}
                                                        onChange={(e) => { setProductValue(e) }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-2">
                                                <div className="form-group">
                                                    <label htmlFor="exampleInputEmail1">Qty</label>
                                                    <input
                                                        type="number"
                                                        onChange={(e) => {
                                                            setProductData({
                                                                ...productData,
                                                                qty: e.target.value,
                                                                amount: (e.target.value * productData.rate) ? e.target.value * productData.rate : 0,
                                                            });
                                                        }}
                                                        value={productData.qty}
                                                        className="form-control"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-2">
                                                <div className="form-group">
                                                    <label htmlFor="exampleInputEmail1">Price</label>
                                                    <input
                                                        type="number"
                                                        onChange={(e) => {
                                                            setProductData({
                                                                ...productData,
                                                                rate: e.target.value,
                                                                amount: (e.target.value * productData.qty) ? e.target.value * productData.qty : 0,
                                                            });
                                                        }}
                                                        value={productData.rate}
                                                        className="form-control"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-2">
                                                <div className="form-group">
                                                    <label htmlFor="exampleInputEmail1">Amount</label>
                                                    <input
                                                        type="text"
                                                        value={productData.amount}
                                                        className="form-control"
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-1">
                                                <div className="form-group">
                                                    <label>&nbsp;</label>
                                                    <div>
                                                        <i style={{ fontSize: 34, cursor: 'pointer' }} onClick={() => addRow()} className="simple-icon-plus"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {items.length > 0 &&
                                        <table className='table table-hover'>
                                            <thead className='thead'>
                                                <tr>
                                                    <th>#</th>
                                                    <th style={{ width: '45%' }}>Product</th>
                                                    <th>Qty</th>
                                                    <th>Price</th>
                                                    <th>GST</th>
                                                    <th>Amount</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    items.map((e, k) => {
                                                        return <tr key={k}>
                                                            <td>{k + 1}</td>
                                                            <td style={{ width: '45%' }}>{e.name}</td>
                                                            <td><input type="number" onChange={(event) => { updateValue('qty', 'amount', event.target.value, k) }} className="form-control form-control-sm" value={e.qty} /></td>
                                                            <td><input type="number" onChange={(event) => { updateValue('rate', 'amount', event.target.value, k) }} className="form-control form-control-sm" value={e.rate} /></td>
                                                            <td><input type="text" className="form-control form-control-sm" value={e.gst + '%'} disabled /></td>
                                                            <td><input type="text" className="form-control form-control-sm" value={e.amount} disabled /></td>
                                                            <td style={{ cursor: "pointer" }}>
                                                                <i style={{ fontSize: 34, cursor: 'pointer' }} onClick={() => { deleteRow(k) }} className="simple-icon-close text-danger"></i>
                                                            </td>
                                                        </tr>
                                                    })
                                                }
                                                <tr className="border-top">
                                                    <td className="border-end" colSpan={4} align={'right'}></td>
                                                    <td className="border-end" align={'right'}><strong>Sub Total</strong></td>
                                                    <td colSpan={1} align={'right'}><strong>{formData.sub_total}</strong></td>
                                                    <td></td>
                                                </tr>
                                                {(formData.insurance) ? <tr className="border-top">
                                                    <td className="border-end" colSpan={4} align={'right'}></td>
                                                    <td className="border-end" align={'right'}><strong>Insurance ({formData.insurance}%)</strong></td>
                                                    <td colSpan={1} align={'right'}><strong>{formData.insurance_amount}</strong></td>
                                                    <td></td>
                                                </tr> : null}
                                                <tr className="border-top">
                                                    <td className="border-end" colSpan={4} align={'right'}></td>
                                                    <td className="border-end" align={'right'}><strong>GST</strong></td>
                                                    <td colSpan={1} align={'right'}><strong>{formData.tax_amount}</strong></td>
                                                    <td></td>
                                                </tr>
                                                <tr className="border-top">
                                                    <td className="border-end vertical-middle">
                                                        <label htmlFor="remarks" className="mb-0">Remark</label>
                                                    </td>
                                                    <td className="border-end" colSpan={3}>
                                                        <input id="remarks" type={'text'} maxLength={255} value={formData.remark} placeholder="Remark" className='form-control' onChange={(e) => setFormData({ ...formData, remark: e.target.value })} />
                                                    </td>
                                                    <td className="border-end vertical-middle" align={'right'}><strong>Round Off</strong></td>
                                                    <td align={'right'}> <input type={'number'} value={formData.round_off} className='form-control form-control-sm text-right' onChange={(e) => setFormData({ ...formData, round_off: e.target.value })} /> </td>
                                                    <td></td>
                                                </tr>
                                                <tr className="border-top">
                                                    <td className="border-end" colSpan={5} align={'right'}><strong>Final Amount</strong></td>
                                                    <td align={'right'}><strong>{formData.total_amount}</strong></td>
                                                    <td></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    }
                                </div>
                            </div>
                        </div>
                    </form>
                    <div className="col-lg-12 col-md-12 col-sm-12 pt-3">
                        <div className="form-group text-right">
                            <button
                                type="button"
                                onClick={onSave}
                                disabled={!isValidForm() || isLoading}
                                className="btn btn-primary" >
                                {isLoading ? <span className="spinner-border spinner-border-sm me-2" role="status"></span> : null}
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AddCashSales;